'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect, useMemo } from 'react';
import { Column, ImgPreview, UploadFileWrapper, Filename, Row, ProgressBarItem, Progress } from './UploadFile.css.js';
import { uploadFile } from './services.js';
import { DEFAULT_OPTIONS } from './constants.js';
import EyesOpenIcon from '../Images/EyesOpenIcon/index.js';
import Trash from '../Images/Trash/index.js';
import { colors } from '../Utils/constants.js';
import Button from '../Button/index.js';

var UploadFile = function (props) {
    var _a = props.file, file = _a === void 0 ? null : _a, apiUpload = props.apiUpload, _b = props.color, color = _b === void 0 ? colors.primaryColor : _b, options = props.options, onClickPreviewButton = props.onClickPreviewButton, onClickDeleteButton = props.onClickDeleteButton, onProgress = props.onProgress, onDone = props.onDone;
    var mergedOptions = __assign(__assign({}, DEFAULT_OPTIONS), options);
    var _c = useState(0), uploadPercent = _c[0], setUploadPercent = _c[1];
    var _d = useState('NONE'), uploadState = _d[0], setUploadState = _d[1];
    var onUploadProgress = function (e) {
        // upload progress as percentage
        var percentCompleted = Math.round((e.loaded / e.total) * 100);
        setUploadPercent(percentCompleted);
        onProgress && onProgress(percentCompleted);
    };
    var onUploadLoad = function (request) {
        if (request.status === 200) {
            setUploadState('SUCCESS');
            onDone && onDone('SUCCESS');
        }
    };
    var onUploadError = function (type) {
        setUploadState('ERROR');
        onDone && onDone('ERROR');
    };
    useEffect(function () {
        if (file === null) {
            return;
        }
        setUploadState('UPLOADING');
        // do bind upload function
        uploadFile({
            file: file,
            apiUpload: apiUpload,
            onProgress: onUploadProgress,
            onLoad: onUploadLoad,
            onError: onUploadError
        });
    }, [file]);
    var renderRightInfo = function () {
        if (uploadState === 'UPLOADING') {
            return React__default.createElement(React__default.Fragment, null,
                uploadPercent,
                "%");
        }
        return (React__default.createElement(Row, null,
            mergedOptions.isShowPreviewButton ? (React__default.createElement(Button, { isRounded: true, isIcon: true, type: 'transparent', onClick: function () { return onClickPreviewButton && onClickPreviewButton(); } },
                React__default.createElement(EyesOpenIcon, null))) : null,
            mergedOptions.isShowDeleteButton ? (React__default.createElement(Button, { isRounded: true, isIcon: true, type: 'transparent', onClick: function () { return onClickDeleteButton && onClickDeleteButton(); } },
                React__default.createElement(Trash, null))) : null));
    };
    var getUploadColor = function () {
        if (uploadState === 'SUCCESS') {
            return colors.successColor;
        }
        else if (uploadState === 'ERROR') {
            return colors.dangerColor;
        }
        return color;
    };
    var renderPreview = useMemo(function () {
        var objBlob = null;
        if (file !== null) {
            objBlob = URL.createObjectURL(file);
        }
        return React__default.createElement(Column, null, objBlob !== null ? React__default.createElement(ImgPreview, { src: objBlob, alt: file === null || file === void 0 ? void 0 : file.name }) : null);
    }, [file]);
    return (React__default.createElement(UploadFileWrapper, null,
        renderPreview,
        React__default.createElement(Column, null,
            React__default.createElement(Filename, null, file === null || file === void 0 ? void 0 : file.name),
            React__default.createElement(Row, null,
                React__default.createElement(Column, null,
                    React__default.createElement(ProgressBarItem, null,
                        React__default.createElement(Progress, { color: getUploadColor(), isUploading: uploadState === 'UPLOADING', style: {
                                width: "".concat(uploadPercent, "%")
                            } }))),
                React__default.createElement(Column, null, renderRightInfo())))));
};

export { UploadFile as default };
//# sourceMappingURL=index.js.map
